// extracted by mini-css-extract-plugin
module.exports = {"slider":"ImagesSlider-module--slider--p4gfH","imageWrapper":"ImagesSlider-module--image-wrapper--1Poh7"};